<div
  class="flex items-center w-167.5 h-12.5 bg-white border border-th-gray-3 rounded-[5px] px-6 gap-5 focus:outline-none focus-within:border-th-blue-highlight-2"
>
  <div class="flex items-center gap-4 min-w-25">
    <img src="icons/flag_pais_chile.svg" alt="Chile" />
    <span class="font-inter text-sm font-medium text-th-black">Chile</span>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 6L8 11L3 6"
        stroke="#ADB2BA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div class="w-px h-8 bg-th-gray-3 shrink-0"></div>

  <div class="flex items-center gap-3 flex-1">
    <svg class="shrink-0" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle
        cx="11"
        cy="11"
        r="8"
        stroke="#0066FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 21L16.65 16.65"
        stroke="#0066FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <input
      type="text"
      class="flex-1 border-none outline-none font-inter text-base font-normal text-th-black bg-transparent placeholder:text-th-blue-placeholder placeholder:text-base"
      [formControl]="searchControl"
      [placeholder]="placeholder()"
      (keydown)="onKeyDown($event)"
    />
    @if (searchControl.value) {
      <button type="button" class="shrink-0 cursor-pointer" (click)="clearSearch()">
        <img src="icons/clear_icon.svg" alt="Limpiar búsqueda" width="24" height="24" />
      </button>
    }
  </div>
</div>
